export class LifecycleModel {
    dateInUse?: Date | null;
    dateOutOfUse?: Date | null;
}